const SplitDown = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="line_start_diamond">
      <mask
        id="mask0_1401_93199"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect
          id="Bounding box"
          width="18"
          height="18"
          transform="matrix(0 1 1 0 0 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1401_93199)">
        <path
          id="line_start_diamond_2"
          d="M12.1313 6.75L9 9.88125L5.86875 6.75L9 3.61875L12.1313 6.75ZM14.25 6.75L9 1.5L3.75 6.75L8.25 11.25V16.5H9.75V11.25L14.25 6.75Z"
          fill="#36A5F0"
        />
      </g>
    </g>
  </svg>
);

export default SplitDown;
